import { apiBlob } from "../../api/client";
import { saveBlob } from "../../lib/download";

// The generic save/CSV helpers live in src/lib/download.ts (the collab console
// uses them too); re-exported here so admin importers keep one import site.
export { downloadCsv, saveBlob } from "../../lib/download";

export async function downloadPhotosZip(): Promise<void> {
  saveBlob(await apiBlob("GET", "/admin/export/photos.zip"), "faceage-photos.zip");
}

// Signed consent copies — platform-wide, or one study's when a slug is given.
export async function downloadConsentsZip(slug?: string): Promise<void> {
  const path = slug ? `/admin/export/consents.zip?study=${slug}` : "/admin/export/consents.zip";
  const filename = slug ? `faceage-consents-${slug}.zip` : "faceage-consents.zip";
  saveBlob(await apiBlob("GET", path), filename);
}
